<template>
  <b-nav class="nav-toggled">
    <!-- <img class="Item" src="@/assets/PentagroIcon2.png" alt="Ícone Pentagro" /> -->
    <b-nav-item-dropdown no-caret :text="$t('harvestPlan')" id="button-harvest-plan" class="toggled" left>
      <b-dropdown-item class="drop-item"
        v-if="this.showPD && user.Permissions.planosdesafra && user.Permissions.planosdesafra.allowed && user.Permissions.planosdesafra.permission"
        :title="user.Permissions.planosdesafra.permission"
        :to="`/plan/${user.Permissions.planosdesafra.parameter}`"
      >
        <img
          class="dropItem"
          src="@/assets/Planejamento.png"
          alt="Planejamento"
        />
        {{ user.Permissions.planosdesafra.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item"
        v-if="this.showBD && user.Permissions.planosdesafrabudget && user.Permissions.planosdesafrabudget.allowed && user.Permissions.planosdesafrabudget.permission"
        :title="user.Permissions.planosdesafrabudget.permission"
        :to="`/plan/${user.Permissions.planosdesafrabudget.parameter}`"
      >
        <img
          class="dropItem"
          src="@/assets/Planejamento.png"
          alt="Planejamento"
        />
        {{ user.Permissions.planosdesafrabudget.permission }}
      </b-dropdown-item>
      
      <b-dropdown-item class="drop-item"
        v-if="user.Permissions.configurarcalendariosazonal && user.Permissions.configurarcalendariosazonal.allowed && user.Permissions.configurarcalendariosazonal.permission"
        :title="user.Permissions.configurarcalendariosazonal.permission"
        :to="`/seasonalindicatorsetup`"
      >
        <img
          class="dropItem"
          src="@/assets/Planejamento.png"
          alt="Planejamento"
        />
        {{ user.Permissions.configurarcalendariosazonal.permission }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PlanoSafraDropdown",
  computed: mapState(["user"]),
  data() {
    return {
      showPD: false,
      showBD: false,
    }
  },
  methods: {
    showDropDown(){
      for (let key in this.user.Permissions){
        if(this.user.Permissions[key] && this.user.Permissions[key].allowed)
        {
          if(key.match(/gerenciarplanosafra/))
            this.showPD = true;

          if(key.match(/gerenciarplanobudget/))
            this.showBD = true
        }
      }
    },
  },
  mounted(){
    this.showDropDown();
  }
};
</script>

<style scoped>
.txt {
  color: white;
  padding: 10px 20px;
}

img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.ilink {
  margin-right: 10px;
}
</style>
